/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type { Registry, RegistryInterface } from "../../contracts/Registry";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_stakingToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_obligationCost",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_tokenCost",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
    ],
    name: "AddTokens",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "FullUnstake",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "InitialStake",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
    ],
    name: "RemoveTokens",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "url",
        type: "string",
      },
    ],
    name: "SetURL",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
    ],
    name: "addTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "getStakersForToken",
    outputs: [
      {
        internalType: "address[]",
        name: "stakers",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
    ],
    name: "getSupportedTokens",
    outputs: [
      {
        internalType: "address[]",
        name: "tokenList",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "stakers",
        type: "address[]",
      },
    ],
    name: "getURLsForStakers",
    outputs: [
      {
        internalType: "string[]",
        name: "urls",
        type: "string[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "getURLsForToken",
    outputs: [
      {
        internalType: "string[]",
        name: "urls",
        type: "string[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "obligationCost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "removeAllTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
    ],
    name: "removeTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_url",
        type: "string",
      },
    ],
    name: "setURL",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "stakerURLs",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "supportsToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenCost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type RegistryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RegistryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Registry__factory extends ContractFactory {
  constructor(...args: RegistryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _stakingToken: PromiseOrValue<string>,
    _obligationCost: PromiseOrValue<BigNumberish>,
    _tokenCost: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<Registry> {
    return super.deploy(
      _stakingToken,
      _obligationCost,
      _tokenCost,
      overrides || {}
    ) as Promise<Registry>;
  }
  override getDeployTransaction(
    _stakingToken: PromiseOrValue<string>,
    _obligationCost: PromiseOrValue<BigNumberish>,
    _tokenCost: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _stakingToken,
      _obligationCost,
      _tokenCost,
      overrides || {}
    );
  }
  override attach(address: string): Registry {
    return super.attach(address) as Registry;
  }
  override connect(signer: Signer): Registry__factory {
    return super.connect(signer) as Registry__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RegistryInterface {
    return new utils.Interface(_abi) as RegistryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Registry {
    return new Contract(address, _abi, signerOrProvider) as Registry;
  }
}
